import terms from "../../../data/about/terms";

const TermsAndConditions = () => {
  return (
    <>
      <div
        style={{
          fontSize: "1.5rem",
          fontWeight: "600",
        }}
        className="animation_box"
      >
        {terms.map((item, key) => {
          return <p key={key}>{item}</p>;
        })}
      </div>
    </>
  );
};

export default TermsAndConditions;
